import { createSlice } from 'common/modules/create-slice';

export interface MarketingUTMs {
    utm_source?: string;
    utm_medium?: string;
    utm_campaign?: string;
    utm_content?: string;
    utm_id?: string;
    utm_channel?: string;
}

export interface UTMsState {
    marketingUTMs: MarketingUTMs;
    hasCapturedInitialUTMs: boolean;
    capturedTimestamp?: number;
}

export const initialUTMsState: UTMsState = {
    marketingUTMs: {},
    hasCapturedInitialUTMs: false,
};

const { update, reducer, configureAction } = createSlice(initialUTMsState, 'UTMS');
export const utmsReducer = reducer;
export const updateUTMs = update;

export const setMarketingUTMs = configureAction<{
    marketingUTMs: MarketingUTMs;
    timestamp?: number;
}>('SET_MARKETING_UTMS', ({ marketingUTMs, timestamp }) => (state) => ({
    ...state,
    marketingUTMs,
    hasCapturedInitialUTMs: true,
    capturedTimestamp: timestamp !== undefined ? timestamp : state.capturedTimestamp,
}));

export const clearMarketingUTMs = configureAction('CLEAR_MARKETING_UTMS', () => (state) => ({
    ...state,
    marketingUTMs: {},
    hasCapturedInitialUTMs: false,
    capturedTimestamp: undefined,
}));

export const areUTMsExpired = (timestamp?: number): boolean => {
    if (!timestamp) {
        return false;
    }
    const now = Date.now();
    const expirationWindowMs = 24 * 60 * 60 * 1000;
    return now - timestamp > expirationWindowMs;
};
